import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import orderService from "../../services/OrderLists";

/**
 * DownloadMyOrder Component
 *
 * Downloads all visible order files as a ZIP archive using the client-facing
 * download API endpoint (v2/task/download/{key}/).
 * Automatically triggers the download on mount and closes the modal once complete.
 *
 * @param {Object} orderData - The order object containing order details (expects orderData.data.key)
 * @param {Function} handleModalClose - Callback to close the parent modal after download
 */
function DownloadMyOrder({ orderData, handleModalClose }) {
  // Track loading state to show/hide spinner
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    /**
     * Initiates the order files download via the client-facing API.
     * Uses the downloadOrderDetailFiles service method which fetches
     * a ZIP blob and triggers a browser download.
     */
    const handleDownload = async () => {
      setLoading(true);
      try {
        // Call the client-facing download API to get all order files as ZIP
        const result = await orderService.downloadOrderDetailFiles(
          orderData?.data?.key
        );
        if (result.success) {
          message.success("Order files downloaded successfully!");
          handleModalClose();
        } else {
          message.error("Failed to download order files.");
          handleModalClose();
        }
      } catch (error) {
        // Close modal on error — error toast is handled by the service layer (catchError)
        handleModalClose();
      } finally {
        setLoading(false);
        handleModalClose();
      }
    };

    // Only trigger download if the order key is available
    if (orderData?.data?.key) {
      handleDownload();
    }
  }, [orderData]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      {/* Spinner shown while the download is in progress */}
      <Spin spinning={loading} tip="Downloading order files..." />
    </div>
  );
}

export default DownloadMyOrder;
